// config.js
// export const base_url = "http://localhost:4000";
// export const base_url = "http://192.168.1.30:4000"
// export const base_url = "https://europeaweb.api.infinydev.com";
export const base_url = "https://euroapi.europea-dms.com";
